import React from 'react';
import { Image } from 'antd';
import * as MaterialProgramTip from '../materialPrograms/MaterialProgramTip';
import { TooltipStyles } from '../Tooltip.styles';
import { 
  IaLegend,
  DivImpactArea,
  DivImpactAreaImage,
  DivImpactAreaName
} from '../dtImpactAreasTip/DtImpactAreasTip.styles';
import { CMFBlockWrapper, LowEmittingText } from './lowEmittingTip.styles';
import * as Tooltip from '../Tooltip';


const LowEmittingTip: React.FC = () => {
    return (
        <MaterialProgramTip.Container>
            <Tooltip.Container spanset={true}>
                <TooltipStyles className='program-cmfdt shadow'>
                    <div className='tooltip-cmf tooltip-cmfdt tooltip-low-emitting'>
                        <h1>Low-emitting</h1>

                        <LowEmittingText>
                            Low-emitting certificates are third-party certifications that verify building materials 
                            have low or no emissions of volatile organic compounds (VOCs), which protects indoor air quality.
                        </LowEmittingText>

                        <IaLegend>
                            <p><b>This document is identified in these Common Materials Framework (CMF) impact areas:</b></p>
                            <CMFBlockWrapper>
                                <DivImpactArea>
                                    <DivImpactAreaImage>
                                    <Image
                                        preview={false}
                                        src={'src/assets/images/health_red_notext.svg'}
                                        style={{ cursor: 'none' }}
                                        width={22} height={22}
                                    />
                                    </DivImpactAreaImage>
                                    <DivImpactAreaName>
                                        Human Health
                                    </DivImpactAreaName>
                                </DivImpactArea>
                            </CMFBlockWrapper>
                        </IaLegend>
                    </div>
                </TooltipStyles>
            </Tooltip.Container>
        </MaterialProgramTip.Container>
    );
};

export default LowEmittingTip;
